import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "currency", "hidden"]
  static values = {
    thousand: String,
    groupingPattern: String
  }

  connect() {
    if (!this.hasInputTarget) return

    this.setSeparatorsFromValues()
    this.pickSelectedCurrencySeparators()

    this.format = this.format.bind(this)
    this.preventInvalid = this.preventInvalid.bind(this)

    this.inputTarget.addEventListener("beforeinput", this.preventInvalid)
    this.inputTarget.addEventListener("input", this.format)

    if (this.inputTarget.value) {
      this.cleanInitialValue()
      this.format()
    }
  }

  setSeparatorsFromValues() {
    this.thousand = this.thousandValue || ","
    this.groupingPattern = this.groupingPatternValue
      ? this.groupingPatternValue.split(",").map(Number)
      : [3]
  }

  currencyChanged(event) {
    const opt = event.target.selectedOptions[0]

    this.thousand = opt.dataset.thousandSeparator || ","
    this.groupingPattern = opt.dataset.groupingPattern
      ? opt.dataset.groupingPattern.split(",").map(Number)
      : [3]

    this.format()
  }

  pickSelectedCurrencySeparators() {
    if (!this.hasCurrencyTarget) return

    const opt = this.currencyTarget.selectedOptions[0]
    if (!opt) return

    this.thousand = opt.dataset.thousandSeparator || this.thousand
    this.groupingPattern = opt.dataset.groupingPattern
      ? opt.dataset.groupingPattern.split(",").map(Number)
      : this.groupingPattern
  }

  cleanInitialValue() {
    const cleaned = this.inputTarget.value.replace(/[^\d]/g, "")
    if (cleaned === "0" || cleaned === "0.00") {
      this.inputTarget.value = ""
      this.updateHidden("")
      return
    } else {
      this.inputTarget.value = cleaned
    }
  }

  preventInvalid(event) {
    if (!event.data) return

    const char = event.data
    if (!/^[0-9]$/.test(char)) {
      event.preventDefault()
    }
  }

  format(event) {
    const input = this.inputTarget
    const oldValue = input.value
    const caretPos = input.selectionStart

    let value = oldValue.replace(/[^\d]/g, "")
    if (!value) {
      this.updateHidden("")
      input.value = ""
      return
    }

    const formatted = this.applyGrouping(value)

    input.value = formatted
    this.updateHidden(value)

    if (event) {
      const diff = formatted.length - oldValue.length
      this.setCaretPosition(input, caretPos + diff)
    }
  }

  applyGrouping(integerPart) {
    if (!integerPart) return ""

    const reversed = integerPart.split("").reverse()
    const groups = []
    let index = 0
    let groupIndex = 0

    while (index < reversed.length) {
      const size =
        this.groupingPattern[groupIndex] ||
        this.groupingPattern[this.groupingPattern.length - 1]
      const part = reversed.slice(index, index + size).reverse().join("")
      groups.unshift(part)
      index += size
      groupIndex += 1
    }

    return groups.join(this.thousand)
  }

  updateHidden(value) {
    if (this.hasHiddenTarget) {
      this.hiddenTarget.value = value
    }
  }

  setCaretPosition(el, pos) {
    requestAnimationFrame(() => {
      const safePos = Math.max(0, Math.min(pos, el.value.length))
      el.setSelectionRange(safePos, safePos)
    })
  }

  disconnect() {
    if (!this.hasInputTarget) return
    this.inputTarget.removeEventListener("beforeinput", this.preventInvalid)
    this.inputTarget.removeEventListener("input", this.format)
  }
}
